export const message = {
  name: "Message |||| Messages",
  fields: {
    body: "Content",
    type: "Type",
    status: "Status",
    sender: "Sender",
    createdAt: "Created at",
  },
  types: {
    text: "Text",
    image: "Image",
    video: "Video",
    audio: "Audio",
    document: "Document",
    location: "Location",
    live_location: "Live Location",
    contact: "Contact",
    poll: "Poll",
    sticker: "Sticker",
    system: "System",
  },
  status: {
    processing: "Processing",
    pending: "Pending",
    sent: "Sent",
    received: "Delivered",
    read: "Read",
    played: "Played",
    failed: "Failed",
  },
  statusHistory: {
    title: "Message Status History",
    empty: "No status history available",
    clickToView: "Click to view status history",
    sending: "Sending...",
  },
  editHistory: {
    title: "Message Edit History",
    empty: "This message has not been edited",
    version: "Version %{smart_count}",
    currentVersion: "Current Version",
    current: "Current",
    emptyContent: "(empty message)",
  },
  actions: {
    editHistory: "Edit History",
    statusHistory: "Status History",
    reply: "Reply",
    forward: "Forward",
    react: "React",
    copy: "Copy",
    edit: "Edit",
    delete: "Delete",
    retry: "Retry",
    sendFailed: "Failed to send",
  },
  notifications: {
    copied: "Copied to clipboard",
    copyFailed: "Failed to copy",
    editSuccess: "Message edited",
    deleteSuccess: "Message deleted",
  },
  reactions: {
    moreEmojis: "More emojis",
    backToQuick: "\u2190 Quick reactions",
    remove: "Remove reaction",
  },
  dialogs: {
    deleteTitle: "Delete Message",
    deleteConfirmation:
      "Are you sure you want to delete this message? This action cannot be undone.",
    deleteTimeRemaining:
      "You have %{time} to delete this message",
    hardDeleteLabel:
      "Delete for everyone (removes message content)",
    hardDeleteHint:
      'The message will show as "deleted" but the content will be permanently removed.',
    editTitle: "Edit Message",
    editPlaceholder: "Edit message...",
    editTimeRemaining: "You have %{time} to edit this message",
  },
};
